<template>
	<div class="service-container" style="height: 100%;">
		<div class="slide" id="slide1_1">
			<h1>虎加行车安全在线培训平台<div></div></h1>
			<div class="disabled">
				<div>
					<div><img src="../../assets/images/s1.png"></div>
					<div class="title">系统化</div>
					<div class="p">培训内容覆盖更全面，从基础到高级技巧，接地气的训课程体系</div>
				</div>

				<div>
					<div><img src="../../assets/images/s2.png"></div>
					<div class="title">自动化</div>
					<div class="p">减少安全员常规培训的繁复劳动，帮助企业降低管理成本，提高效率</div>
				</div>

				<div>
					<div><img src="../../assets/images/s3.png"></div>
					<div class="title">数据化</div>
					<div class="p">培训数据后台留存，帮助企业落实安全生产主体责任</div>
				</div>
			</div>

			<ul>
				<li><img src="../../assets/images/s4.png"></li>
				<li><img src="../../assets/images/s5.png"></li>
			</ul>
		</div>

		<div class="slide" id="slide1_2">
			<h1>让AI改变驾驶安全<div></div></h1>
			<h4>行车安全解决方案</h4>
			<div id="mountNode"></div>
			<div class="title">渣土建设交通事故率，逐年递减</div>
		</div>
	</div>
</template>

<script>
	export default {}
</script>

<style lang="scss"></style>
